import "./Form.css";

import {
  Breadcrumb,
  Input,
  message,
  Table,
  type TableColumnsType,
  Tag,
} from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import {
  SectionHeader,
  TableMenuDropdown,
  UploadFormCsvModal,
} from "../../_lib/_components";
import {
  deleteForm,
  type FormType,
  getForms,
  useAppSelector,
} from "../../_lib/_store";

export const FormPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading, forms } = useAppSelector((state) => state.form);
  const [search, setSearch] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    await getForms(messageApi);
  };

  const columns: TableColumnsType<FormType> = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      sorter: (a, b) => a.title.localeCompare(b.title),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
    },
    {
      title: "Package Id",
      dataIndex: "package",
      key: "package",
      render: (_, obj) => <p>{obj?.package?.name}</p>,
    },
    {
      title: "Category Id",
      dataIndex: "category",
      key: "category",
      render: (_, obj) => <p>{obj?.category?.name}</p>,
    },
    {
      title: "Sub Category Id",
      dataIndex: "subCategoryId",
      key: "subCategoryId",
      render: (_, obj) => <p>{obj?.subCategory?.name}</p>,
    },
    {
      title: "Form Body",
      dataIndex: "formBody",
      key: "formBody",
      render: (_, obj) => <p>{obj?.formBody?.fields?.length}</p>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (v) => <Tag color="gray">{v}</Tag>,
    },
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      width: 100,
      render: (_, obj) => (
        <TableMenuDropdown onClick={(key) => handleMenuClick(key, obj)} />
      ),
    },
  ];

  const filtered = forms?.filter((v) =>
    v?.title?.toLowerCase().includes(search.toLowerCase()),
  );

  const handleMenuClick = (key: string, obj: FormType) => {
    switch (key) {
      case "show":
        navigate(`/form/show`, { state: { form: obj } });
        break;
      case "edit":
        navigate(`/form/edit`, { state: { form: obj } });
        break;
      case "delete":
        deleteForm(messageApi, obj?.id, true);
        break;
      default:
        break;
    }
  };

  return (
    <>
      {contextHolder}
      <div className="form">
        <div className="header">
          <Breadcrumb
            items={[
              {
                title: <Link to="/dashboard">Dashboard</Link>,
              },
              {
                title: "Form",
              },
            ]}
          />
          <div className="headerRight">
            <Input
              style={{ width: "300px", display: "none" }}
              placeholder="Search..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              allowClear
            />
            <UploadFormCsvModal />
          </div>
        </div>
        <SectionHeader dataLength={forms?.length} createRoute="form" />
        <Table
          sticky
          dataSource={filtered}
          columns={columns}
          loading={isLoading}
          scroll={{ x: 1200 }}
          rowKey={"id"}
        />
      </div>
    </>
  );
};
